// File: frontend/src/components/layout/AdminPageTemplate.js

import React from 'react';
import PageHeader from './PageHeader';
import PageContainer from './PageContainer';
import EmptyState from '../utility/EmptyState';
import { Construction } from 'lucide-react';
import styles from './AdminPageTemplate.module.css';

const AdminPageTemplate = ({ 
  title, 
  subtitle, 
  icon: Icon,
  children,
  showComingSoon = false,
  actions = null
}) => {
  return (
    <PageContainer>
      <PageHeader 
        title={title}
        subtitle={subtitle}
        showBack={true}
        backTo="/dashboard"
        actions={actions}
      />
      
      {showComingSoon ? (
        <EmptyState
          icon={Icon || Construction}
          title="Coming Soon"
          description={`${title} is currently under development. Check back soon for updates.`}
        />
      ) : (
        <div className={styles.content}>
          {children}
        </div>
      )}
    </PageContainer>
  );
};

export default AdminPageTemplate;